import { reaction as mobxReaction, when as mobxWhen } from "mobx";
export class Disposer {
    constructor() {
        this.disposers = [];
    }
    reaction(expression, effect, opts) {
        return this.track(mobxReaction(expression, effect, opts));
    }
    when(predicate, effect, opts) {
        return this.track(mobxWhen(predicate, effect, opts));
    }
    track(disposer) {
        this.disposers.push(disposer);
        return disposer;
    }
    dispose() {
        this.disposers.forEach((disposer) => disposer());
        this.disposers = [];
    }
}
